/**
 * Admin-managed platform feature toggles.
 *
 * Stored as a singleton Firestore document at `settings/features`.
 * Flags default to the most cautious value (feature OFF) so a missing doc
 * or a failed fetch never accidentally exposes a gated feature.
 */
export interface FeatureFlags {
  /**
   * When false, the Raffle fundraiser category is hidden from listing
   * creation and all buyer-facing category navigation. Off by default —
   * raffle ticket sales in NZ schools require a gambling licence.
   */
  raffleEnabled: boolean
  /**
   * When true, signed-in users with an unverified email are hard-gated to
   * /verify-email until they click the link in their inbox. On by default —
   * switch off temporarily so testers with fake email addresses can use the
   * platform without verifying.
   */
  emailVerificationRequired: boolean
}

/** Used when the singleton doc doesn't exist yet, or on fetch failure. */
export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  raffleEnabled: false,
  emailVerificationRequired: true,
}
